import { useDispatch } from "react-redux";
import { Card, Typography } from "@mui/material";
import { signOut } from "@/legacy/redux";
import { LinkButton } from "@/components";
import Button from "@imminently/decisively-ui/Button";

const LoginError = () => {
  const dispatch = useDispatch();
  const signout = () => {
    dispatch(signOut());
  };
  return (
    <Card className="flex flex-col items-center gap-4 px-16 py-8">
      <Typography component="h1" variant="h1" align="center">
        Authentication Failed
      </Typography>

      <div>
        <Typography component="h2" variant="h5" align="center">
          Something went wrong.
        </Typography>
        <Typography align="center">
          Please contact support or attempt to try in again
        </Typography>
      </div>


      <div className="flex flex-row items-center justify-center gap-4">
        <LinkButton to="/">
          Return to website
        </LinkButton>
        <Button type="button" variant="ghost" onClick={signout} label="Sign out">
          Sign out
        </Button>
      </div>
    </Card>
  );
};

export default LoginError;
